export const theme = {
  primaryColor: 'var(--primary-color)',
};
export type Theme = typeof theme;
